import React from "react";
import { Chart } from "primereact/chart";
import ChartDivider from "../../ChartDivider";
import ChartSkeleton from "../../../Skeletons/ChartSkeleton";
import { getOuncePerUSeChartOptions } from "../../../../utils/chartOptions/dashboard/amount";
const OuncesPerUse = React.memo(function OuncesPerUse(props) {
  const options = getOuncePerUSeChartOptions(
    props?.chartData,
    props?.activeTag,
  );

  return (
    <>
      <div className="mt-4" style={{ maxWidth: "100%" }}>
        <div className="mb-4">
          <h5 className="fw-bold mb-1 text-start">
            {props?.activeTag === "OZ" ? "Ounces per Use" : "Grams per Use"}
          </h5>
          <p
            className="mb-0 text-start fw-bold fs-12 py-3"
            style={{ color: "#6c757d" }}
          >
            Average {props?.activeTag === "OZ" ? "ounces" : "grams"} used per
            occasion
          </p>
          <div className="col-12">
            {!props?.loading ? (
              <Chart
                type="bar"
                data={props?.chartData}
                options={options}
                redraw={(props?.isFilterHide || props?.showSidebar).toString()}
              />
            ) : (
              <ChartSkeleton />
            )}
          </div>
          <ChartDivider />
        </div>
      </div>
    </>
  );
});

export default OuncesPerUse;
